import { getInternalAppSdk } from '@/utils/internalAppSdk'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { SECOND_IN_MILLISECONDS } from '@vaultsfyi/common/constants'
import type { CctpMoneyInTransitResponse, CctpMoneyInTransitRouteItem } from '@vaultsfyi/common/schemas'
import type { Address } from 'viem'

export type { CctpMoneyInTransitRouteItem as CctpMoneyInTransitItem }

const cctpMoneyInTransitQueryKey = ['cctpMoneyInTransit'] as const

const cctpMoneyInTransitQueryOptions = (userAddress: Address | undefined) =>
  queryOptions({
    queryKey: [...cctpMoneyInTransitQueryKey, { userAddress }] as const,
    queryFn(): Promise<CctpMoneyInTransitResponse> {
      const internalAppSdk = getInternalAppSdk()

      return internalAppSdk.getCctpMoneyInTransit(userAddress!)
    },
    enabled: !!userAddress,
    retry: 1,
    staleTime: 15 * SECOND_IN_MILLISECONDS,
    refetchInterval: 10 * SECOND_IN_MILLISECONDS,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  })

export function useCctpMoneyInTransitQuery(userAddress: Address | undefined) {
  return useQuery(cctpMoneyInTransitQueryOptions(userAddress))
}
